import CssBaseline from '@mui/material/CssBaseline';
import {StyledEngineProvider} from '@mui/material/styles';
import ThemeProvider from '@mui/material/styles/ThemeProvider';
import type {FC} from 'react';
import {createRoot} from 'react-dom/client';
import {BrowserRouter} from 'react-router-dom';
import AdminApp from '@/admin/AdminApp';
import Routes from './routes/routes';
import theme from './theme/theme';

import './i18n';
import FullScreenWrapper from '@/components/Layouts/FullScreenWrapper';

const isAdminRoute = window.location.pathname.startsWith('/admin');

const AdminRoot: FC = () => (
  <BrowserRouter basename="/admin">
    <AdminApp />
  </BrowserRouter>
);

const App: FC = () => {
  if (isAdminRoute) {
    return <AdminRoot />;
  }

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme()}>
        <CssBaseline />
        <FullScreenWrapper>
          <Routes />
        </FullScreenWrapper>
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

const container = document.getElementById('app');
if (container) {
  const root = createRoot(container);
  root.render(<App />);
}

export default App;
